/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpSharedContactDealerButton_user$ref = any;
export type PdpSharedShippingInfoLink_user$ref = any;
export type PdpSharedShippingInfoLink_user = {
    readonly canRequestShippingQuotePermission: boolean | null;
    readonly profile: {
        readonly email: string | null;
    } | null;
    readonly authMetadata: {
        readonly emailOnly: boolean | null;
    } | null;
    readonly " $fragmentRefs": PdpSharedContactDealerButton_user$ref;
    readonly " $refType": PdpSharedShippingInfoLink_user$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "PdpSharedShippingInfoLink_user",
    "type": "User",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "canRequestShippingQuotePermission",
            "name": "hasPermission",
            "args": [
                {
                    "kind": "Literal",
                    "name": "name",
                    "value": "B_REQUEST_SHIPPING_QUOTE"
                }
            ],
            "storageKey": "hasPermission(name:\"B_REQUEST_SHIPPING_QUOTE\")"
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "profile",
            "storageKey": null,
            "args": null,
            "concreteType": "Profile",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "email",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "authMetadata",
            "storageKey": null,
            "args": null,
            "concreteType": "UserExistsMetadataType",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "emailOnly",
                    "args": null,
                    "storageKey": null
                }
            ]
        },
        {
            "kind": "FragmentSpread",
            "name": "PdpSharedContactDealerButton_user",
            "args": null
        }
    ]
} as any);
(node as any).hash = 'e02e513cbf0b768d3d1ab1c60754c140';
export default node;
